import { triggerLayerChanged } from "../helpers/canvasHelpers";
import { BasicExtensionFactory, Canvas } from "../types/canvasTypes";
import { findBackgroundImage } from "../utils/backgroundUtils";
import { findViewportShape } from "../utils/viewportUtils";

const NAME = "layer-manager";

export type LayerChangeMode = "bringForward" | "sendBackwards" | "sendToBack" | "bringToFront";

export type ChangeLayerFunction = (mode: LayerChangeMode) => void;
export const createLayerManagerExtension: BasicExtensionFactory<{
  changeLayerFunctionFactory: (fn: ChangeLayerFunction) => void;
}> = (options) => {
  return {
    name: NAME,
    onInit: (canvas) => {
      if (!options?.changeLayerFunctionFactory) return;

      options.changeLayerFunctionFactory((mode: LayerChangeMode) => {
        if (!canvas) return;

        const currentObject = canvas.getActiveObject();
        if (!currentObject) return;

        if (mode === "bringForward") {
          canvas.bringForward(currentObject);
        } else if (mode === "sendBackwards") {
          canvas.sendBackwards(currentObject);
        } else if (mode === "sendToBack") {
          canvas.sendToBack(currentObject);
        } else if (mode === "bringToFront") {
          canvas.bringToFront(currentObject);
        }

        // Send background image and viewport to the back in case user send current object to the back
        if (mode === "sendBackwards" || mode === "sendToBack") {
          sendBackgroundImageToBackIfExits(canvas);
          sendViewportToBack(canvas);
        }

        triggerLayerChanged(canvas);
      });
    },
  };
};

function sendBackgroundImageToBackIfExits(canvas: Canvas) {
  const backgroundImage = findBackgroundImage(canvas);
  if (backgroundImage) {
    canvas.sendToBack(backgroundImage);
  }
}
function sendViewportToBack(canvas: Canvas) {
  const viewPort = findViewportShape(canvas);
  if (viewPort) {
    canvas.sendToBack(viewPort);
  }
}
